import { render, staticRenderFns } from "./PaymentPastDueCard.vue?vue&type=template&id=281d7606&scoped=true"
import script from "./PaymentPastDueCard.vue?vue&type=script&lang=js"
export * from "./PaymentPastDueCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentPastDueCard.vue?vue&type=style&index=0&id=281d7606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281d7606",
  null
  
)

export default component.exports